import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from '@mui/material';
import {useTranslation} from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../../../api/axios';

type Props = {
  open: boolean;
  userId?: number;
  userEmail?: string;
  onClose: () => void;
  onDeleted: () => void;
};

const UserDeleteModal = ({ open, userId, userEmail, onClose, onDeleted }: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);


  const handleDelete = async () => {
    if (!userId) return;


    setLoading(true);
    try {
      await api.post(`/user/${userId}/remove-deletion-by-admin`);

      onDeleted();
      onClose();
    } catch (error) {
      console.error('Fehler beim Löschen des Benutzers:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <div className="relative">
          <DialogTitle>{t('system.user.removeDeletion.title')}</DialogTitle>
          <IconButton
              aria-label="close"
              onClick={onClose}
              className="!absolute right-3 top-3 text-blue-600 hover:text-blue-800"
          >
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent className="space-y-4">
          <div>{t('system.user.removeDeletion.text', { email: userEmail })}</div>
        </DialogContent>

          <DialogActions className="mr-4 mb-4">
          <Button onClick={onClose} className="text-gray-700 dark:text-gray-200">
            {t('system.user.removeDeletion.cancel')}
          </Button>
          <Button
              variant="contained"
              color="primary"
              onClick={handleDelete}
              disabled={
                  loading ||
                  !userId
              }
          >
            {t('system.user.removeDeletion.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default UserDeleteModal;
